<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.agentName" placeholder="代理名称" aria-label="代理名称"
        style="width: 180px" class="filter-item" clearable @keyup.enter.native="handleFilter" />
      <el-select
        v-model="listQuery.teamLogo"
        placeholder="代理所属（全部）"
        label="代理所属"
        style="width: 170px"
        class="filter-item"
        clearable
      >
        <el-option
          v-for="item in AGENT_AFFILIATION"
          :key="item.key"
          :label="item.value"
          :value="item.key"
        />
      </el-select>
      <el-input
        v-model="listQuery.keyword"
        placeholder="账号 / 姓名 / 证件号码"
        aria-label="账号、姓名或证件号码"
        style="width: 300px"
        class="filter-item"
        clearable
        @keyup.enter.native="handleFilter"
      />

      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button class="filter-item" @click="resetFilters">重置</el-button>
    </div>

    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      size="small"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" prop="id" label="ID" width="95"></el-table-column>
      <el-table-column label="姓名" align="center" prop="name"></el-table-column>
      <el-table-column label="代理名称" align="center" prop="agentName"></el-table-column>
      <el-table-column label="归属地" align="center" prop="regionAddress" min-width="190" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.regionAddress || (scope.row.regionId > 0 ? '地区信息缺失' : '未设置') }}
        </template>
      </el-table-column>
      <el-table-column label="代理所属" align="center" prop="teamLogo" width="100">
        <template slot-scope="scope">{{ affiliationLabel(scope.row.teamLogo) }}</template>
      </el-table-column>

      <el-table-column align="center" prop="certStatus" label="实名认证状态" width="100">
        <template slot-scope="scope">
          <span>{{ getValue(MEMBER_CER_STATUS, scope.row.certStatus) }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <span>{{ getValue(MEMBER_STATUS, scope.row.status) }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="contractStatus" label="合同状态" width="100">
        <template slot-scope="scope">
          <span>{{ getValue(CONTRACT_STATUS, scope.row.contractStatus) }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="isAgentLogin" label="是否允许代理商登录" width="100px">
        <template slot-scope="scope">
          <span>{{ getValue(IS_AGENT_LOGIN_ENUM, scope.row.isAgentLogin) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="代理业绩" align="center" prop="performance"></el-table-column>
      <el-table-column
        label="下级代理数量"
        align="center"
        prop="subordinateCount"
      ></el-table-column>

      <el-table-column align="center" prop="referrerAgent" label="推荐代理标识" width="100px">
        <template slot-scope="scope">
          <span>{{ getValue(REFERRETR_ANGENT_ENUM, scope.row.referrerAgent) }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" prop="ctdate" label="创建时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.ctdate) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="mddate" label="修改时间" width="200px">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span>{{ formatApiDate(scope.row.mddate) }}</span>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="checkDialogFormVisible(scope.row)"
            class="comm_but_warp"
            >新增</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog :visible.sync="dialogFormVisible" v-if="dialogFormVisible" :append-to-body="true">
      <div class="dialog-view">
        <span style="font-size:30px;" class="dia-pos">新增代理合伙人</span>
        <div class="dialog-content">
          <div class="dialog-left">
            会员ID:
          </div>
          <div class="dialog-right">
            {{ curRow.userId }}
          </div>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            合伙人ID:
          </div>
          <div class="dialog-right">
            <el-input style="width: 200px" v-model="curRow.partnerId" placeholder="请输入" />
          </div>
        </div>
        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            分红比例:
          </div>
          <div class="dialog-right">
            <el-input
              style="width: 200px"
              v-model="curRow.ration"
              placeholder="请输入0~1之间的数字"
              type="number"
              :min="0"
              :max="1"
              :step="0.01"
              @input="handleRationInput"
            />
          </div>
        </div>

        <div class="dialog-content" style="margin-top:20px">
          <div class="dialog-left">
            代理所属:
          </div>
          <div class="dialog-right">
            <el-select
              v-model="curRow.teamLogo"
              placeholder="请选择"
              style="width: 200px"
              class="filter-item"
              clearable
            >
              <el-option
                v-for="item in AGENT_AFFILIATION"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </div>
        </div>
      </div>
      <el-button @click="onClose">取 消</el-button>
      <el-button type="primary" @click="onBoHui">确 定</el-button>
    </el-dialog>
  </div>
</template>

<script>
import { getAgentList1027, addAgentPartnerArea } from "@/api/agent";
import { formatApiDate } from "@/utils/utils";
import {
  getValue,
  MEMBER_STATUS,
  MEMBER_CER_STATUS,
  CONTRACT_STATUS,
  IS_AGENT_LOGIN_ENUM,
  REFERRETR_ANGENT_ENUM
} from "@/utils/enumUtile";

export default {
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      dialogFormVisible: false,
      listQuery: {
        page: 1,
        pageSize: 10,
        teamLogo: null,
        agentName: null,
        keyword: null
      },
      curRow: null,
      ration: "",
      listRequestId: 0
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getValue,
    affiliationLabel(value) {
      if (value === 0 || value === "0") return "地图";
      if (value === 1 || value === "1") return "推荐";
      return "未设置";
    },
    resetFilters() {
      this.listQuery = { page: 1, pageSize: this.listQuery.pageSize, teamLogo: null, agentName: null, keyword: null };
      return this.getList();
    },
    onBo(row) {
      this.curRow = row;
      this.dialogFormVisible = true;
    },
    onBoHui() {
      if (
        !this.curRow ||
        this.curRow.ration === "" ||
        this.curRow.ration === null ||
        this.curRow.ration === undefined
      ) {
        this.$message.warning("请输入分红比例");
        return;
      }
      const num = parseFloat(this.curRow.ration);
      if (isNaN(num) || num < 0 || num > 1) {
        this.$message.warning("分红比例必须在 0 ~ 1 之间");
        return;
      }
      addAgentPartnerArea({
        userId: this.curRow.userId,
        partnerId: this.curRow.partnerId,
        ration: this.curRow.ration,
        teamLogo: this.curRow.teamLogo
      }).then(res => {
        if (res.bizcode === 100) {
          this.$message.success("新增成功");
          this.getList();
          this.onClose();
        }
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    getList() {
      const requestId = ++this.listRequestId;
      this.listLoading = true;
      // 仅提交显式筛选，0是“地图”，不能用真假值判断而漏掉。
      const params = { page: this.listQuery.page, pageSize: this.listQuery.pageSize };
      ["teamLogo", "agentName", "keyword"].forEach(key => {
        const value = this.listQuery[key];
        if (value !== null && value !== undefined && value !== "") params[key] = typeof value === "string" ? value.trim() : value;
      });
      return getAgentList1027(params).then(res => {
        if (requestId !== this.listRequestId) return;
        if (!res || res.bizcode !== 100 || !res.data) throw new Error((res && res.msg) || "代理列表加载失败");
        this.list = res.data.entitys;
        this.total = res.data.totalCount;
      }).catch(error => {
        if (requestId !== this.listRequestId) return;
        this.list = [];
        this.total = 0;
        this.$message.error(error.message || "代理列表加载失败，请重试");
      }).finally(() => {
        if (requestId === this.listRequestId) this.listLoading = false;
      });
    },
    onClose() {
      this.remark = "";
      this.curRow = null;
      this.dialogFormVisible = false;
    },
    handleRationInput(val) {
      if (!this.curRow) return;
      if (val === "" || val === null || val === undefined) {
        this.curRow.ration = "";
        return;
      }
      let valStr = String(val).replace(/[^\d.]/g, "");
      const parts = valStr.split(".");
      if (parts.length > 2) {
        valStr = parts[0] + "." + parts.slice(1).join("");
      }
      const num = parseFloat(valStr);
      if (!isNaN(num)) {
        if (num > 1) {
          valStr = "1";
        } else if (num < 0) {
          valStr = "0";
        }
      }
      this.curRow.ration = valStr;
      this.$nextTick(() => {
        if (this.curRow) {
          this.curRow.ration = valStr;
        }
      });
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val;
      this.listQuery.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    checkDialogFormVisible(item) {
      this.curRow = { ...item, userId: item.id };
      this.dialogFormVisible = true;
    }
  },
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    MEMBER_STATUS() {
      return MEMBER_STATUS;
    },
    MEMBER_CER_STATUS() {
      return MEMBER_CER_STATUS;
    },
    CONTRACT_STATUS() {
      return CONTRACT_STATUS;
    },
    IS_AGENT_LOGIN_ENUM() {
      return IS_AGENT_LOGIN_ENUM;
    },
    REFERRETR_ANGENT_ENUM() {
      return REFERRETR_ANGENT_ENUM;
    },
    AGENT_AFFILIATION() {
      return [{ key: 0, value: "地图" }, { key: 1, value: "推荐" }];
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-view {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 30px;
  position: relative;

  .dialog-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    .dialog-left {
      width: 200px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }

    .dialog-right {
      flex: 1;
      margin-left: 20px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
  }

  .dia-pos {
    position: absolute;
    top: -70px;
  }
}

.image-wrapper {
  position: relative;
  display: inline-block;
  margin-right: 8px;
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  .download-btn {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(64, 158, 255, 0.9);
    border: none;
    color: #fff;
    font-size: 12px;
    padding: 4px 10px;
    border-radius: 16px;
    opacity: 0;
    transition: all 0.3s ease;
    cursor: pointer;

    &:hover {
      background: rgba(64, 158, 255, 1);
      transform: translateX(-50%) scale(1.05);
    }
  }

  &:hover .download-btn {
    opacity: 1;
  }
}

.upload-list {
  ::v-deep .upload_list_warp {
    .el-upload {
      width: 80px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  ::v-deep .el-upload__tip {
    display: none;
  }
}
</style>
